import { Document_Competency_Map_Question_Type, Grade, Language } from "@generated/graphql";
import { EvaluationType, PromptSlideId } from "./types";

export const MAX_GENERATION_DOCUMENTS = 5;

export const DOCUMENT_ACCEPT =
  // eslint-disable-next-line max-len
  ".txt,.md,.docx,.json,.pdf,text/plain,text/markdown,application/json,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document";

export const QUESTION_TYPE_ERROR_MESSAGE = "Выберите хотя бы один тип вопросов";
export const MAX_ESTIMATED_DURATION = 180;

export const QUESTION_TYPE_OPTIONS = [
  {
    id: Document_Competency_Map_Question_Type.PracticalConcreteAnswer,
    label: "Практический: Предоставление ответа",
    shortLabel: "Конкретный ответ",
    durationMinutes: 5,
    defaultCount: 2,
  },
  {
    id: Document_Competency_Map_Question_Type.PracticalAnalysis,
    label: "Практический: На размышление",
    shortLabel: "На размышление",
    durationMinutes: 7,
    defaultCount: 2,
  },
  {
    id: Document_Competency_Map_Question_Type.PracticalErrorFinding,
    label: "Практический: На нахождение ошибок",
    shortLabel: "Поиск ошибок",
    durationMinutes: 6,
    defaultCount: 0,
  },
  {
    id: Document_Competency_Map_Question_Type.PracticalCaseBased,
    label: "Практический: На основе кейса",
    shortLabel: "Кейс",
    durationMinutes: 10,
    defaultCount: 0,
  },
  {
    id: Document_Competency_Map_Question_Type.PracticalNumeric,
    label: "Практический: Числовая задача",
    shortLabel: "Числовая задача",
    durationMinutes: 8,
    defaultCount: 0,
  },
  {
    id: Document_Competency_Map_Question_Type.Theoretical,
    label: "Теоретический",
    shortLabel: "Теория",
    durationMinutes: 4,
    defaultCount: 2,
  },
  {
    id: Document_Competency_Map_Question_Type.McqTheoretical,
    label: "Тестовый: Теоретические",
    shortLabel: "Тест теория",
    durationMinutes: 2,
    defaultCount: 0,
  },
  {
    id: Document_Competency_Map_Question_Type.McqCaseBased,
    label: "Тестовый: На основе кейса",
    shortLabel: "Тест кейс",
    durationMinutes: 4,
    defaultCount: 0,
  },
] as const;

export const LANGUAGE_BUTTONS = [
  { id: Language.Ru, label: "RU", description: "Русский" },
  { id: Language.Kk, label: "KZ", description: "Казахский" },
  { id: Language.En, label: "EN", description: "Английский" },
  { id: Language.Uz, label: "UZ", description: "Узбекский" },
] as const;

export const GRADE_BUTTONS = [
  { label: Grade.Junior, difficulty: 2 },
  { label: Grade.Middle, difficulty: 5 },
  { label: Grade.Senior, difficulty: 8 },
] as const;

export const EVALUATION_TYPE_OPTIONS: Array<{
  id: EvaluationType;
  label: string;
  rangeLabel: string;
  tokens: number;
}> = [
  { id: "screening", label: "Скрининг", rangeLabel: "до 30 мин · 1 токен", tokens: 1 },
  { id: "assessment", label: "Ассессмент", rangeLabel: "30–90 мин · 3 токена", tokens: 3 },
  { id: "extended", label: "Расширенный", rangeLabel: ">90 мин · 6 токенов", tokens: 6 },
];

export const PROMPT_SLIDES: Array<{
  id: PromptSlideId;
  icon: string;
  title: string;
  description: string;
}> = [
  {
    id: "globalPrompt",
    icon: "Общий",
    title: "Общий промпт",
    description: "Описание цели оценки, акценты, чего избегать",
  },
  {
    id: "questionsPrompt",
    icon: "Вопросы",
    title: "К вопросам",
    description: "Требования к формату и структуре вопросов",
  },
  {
    id: "criteriaPrompt",
    icon: "Критерии",
    title: "К критериям оценки",
    description: "Что считается ошибкой, что считается сильным ответом",
  },
  {
    id: "tonePrompt",
    icon: "Тон",
    title: "Тональность и контекст",
    description: "Стиль обращения и контекст компании",
  },
];
